<span #description class="chart-dashlet__description">{{ dashlet.description }}</span>
<p-chart #chart [type]="dashlet.chartType || 'line'" [height]="height" [data]="data" [options]="options"></p-chart>
